import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { CoordsButton } from "../Components/CoordsButton";
import React, { useEffect, useState } from "react";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import RemoveCircleTwoToneIcon from "@mui/icons-material/RemoveCircleTwoTone";
import { UnidadMedida } from "../Components/UnidadMedida";
import {
  addEspaceCharacters,
  constantes,
  instance,
} from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";
import CloseIcon from "@mui/icons-material/Close";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";

function ActividadAgregar() {
  const [coords, setScoords] = useState();
  const [unidades, setUnidades] = useState([{ unidad: "", cantidad: 0 }]);
  const [upse, setUPSE] = useState({ Id: "", Nombre: "" });
  const [responsable, setResponsable] = useState({ Id: "", Nombre: "" });
  const [catalogo, setCatalogo] = useState({ Id: "", Nombre: "" });
  const [producto, setProducto] = useState({ Id: "", Nombre: "" });
  const [departamento, setDepartamento] = useState({ Id: "", Nombre: "" });
  const [municipio, setMunicipio] = useState({ Id: "", Nombre: "" });
  const [openDialog, setOpenDialog] = useState(false);
  const [addCoords, setAddCoords] = useState(false);
  const { user } = useAuth();
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Actividad",
    pageState: {},
  });

  function agregarUnidad() {
    setUnidades((current) => [...current, { unidad: "", cantidad: 0 }]);
    //console.log(unidades)
  }
  function eliminarUnidad() {
    setUnidades([...unidades.slice(0, unidades.length - 1)]);
  }

  function validarUnidadesDistintas(arrayObjetos) {
    // Creamos un conjunto vacío para almacenar los números de unidades ya encontrados
    const conjuntoUnidades = new Set();

    // Recorremos el array de objetos
    for (const objeto of arrayObjetos) {
      // Obtenemos el número de unidades del objeto
      const unidad = objeto.unidad;

      // Si el número de unidades ya se encuentra en el conjunto, la validación falla
      if (conjuntoUnidades.has(unidad)) {
        return false;
      }

      // Agregamos el número de unidades al conjunto
      conjuntoUnidades.add(unidad);
    }

    // La validación pasa
    return true;
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      id: user.id,
      upse: upse.Id,
      responsable: responsable.Id,
      descripcion: addEspaceCharacters(info.descripcion.value),
      resultado: addEspaceCharacters(info.resultado.value),
      municipio: municipio.Id,
      producto: producto.Id,
      localidad: addEspaceCharacters(info.localidad.value),
      coordenadas: addCoords
        ? addEspaceCharacters(info.coordenadas.value)
        : "No especifica.",
      meta: addEspaceCharacters(info.meta.value),
      aprobado: info.aprobado.value,
      catalogo: catalogo.Id,
      unidades: unidades,
    };
    //Validar que no existan unidades repetidas
    if (!validarUnidadesDistintas(unidades)) {
      setDialog({
        title: "ERROR",
        text: "Solamente puede existir un único registro de cada unidad.",
      });
      setOpenDialog(true);
      return;
    }
    instance
      .post("actividad/", form)
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "La actividad ha sido registrada exitosamente.",
          redirect: true,
          page: "/UPSE1",
          pageState: { id: upse.Id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };
  return (
    <LoaderBox>
      <Container
        maxWidth="lg"
        sx={{ border: { xs: "0", sm: "1px solid #000" }, mt: 2 }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} padding={2} rowSpacing={1}>
              <Grid item xs={12}>
                <DropDownList
                  required
                  title="UPSE"
                  endpoint={"/upse/listActive"}
                  selectedItem={upse}
                  setSelectedItem={setUPSE}
                />
              </Grid>
              <Grid item xs={12}>
                <DropDownList
                  required
                  title="Responsable"
                  endpoint={"/users/listActive"}
                  selectedItem={responsable}
                  setSelectedItem={setResponsable}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="descripcion"
                  label="Descripción"
                  name="descripcion"
                  inputProps={{ maxLength: 500 }}
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Departamento"
                  endpoint={"/localidad/listActiveDepartamento"}
                  selectedItem={departamento}
                  setSelectedItem={setDepartamento}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Municipio"
                  endpoint={
                    departamento.Id !== ""
                      ? `/localidad/listActiveMunicipio/${departamento.Id}`
                      : undefined
                  }
                  selectedItem={municipio}
                  setSelectedItem={setMunicipio}
                  disabled={departamento.Id === ""}
                  hierarchyUpdated={departamento}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{ display: addCoords ? "block" : "none" }}
              >
                <TextField
                  margin="normal"
                  required={addCoords}
                  fullWidth
                  id="coordenadas"
                  label="Coordenadas"
                  name="coordenadas"
                  inputProps={{ maxLength: 150 }}
                  value={coords}
                  onChange={(e) => setScoords(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <CoordsButton
                    title="Obtener ubicación actual"
                    color="primary"
                    output={setScoords}
                  />
                  <IconButton
                    variant="contained"
                    color="error"
                    onClick={() => setAddCoords(false)}
                    sx={{}}
                  >
                    <Tooltip title="Cerrar agregar coordenadas">
                      <CloseIcon />
                    </Tooltip>
                  </IconButton>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  display: addCoords ? "none" : "flex",
                }}
              >
                <IconButton
                  variant="contained"
                  color="success"
                  onClick={() => setAddCoords(true)}
                  size="small"
                >
                  <Tooltip title='Si no se agregan se guardará como "No especifica"'>
                    <span>
                      <AddLocationAltIcon fontSize="large" />
                      Agregar coordenadas
                    </span>
                  </Tooltip>
                </IconButton>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="aprobado"
                  label="Presupuesto Aprobado"
                  name="aprobado"
                  type="number"
                  inputProps={{
                    step: constantes.decimales_dinero,
                    min: 0,
                    style: { textAlign: "right" },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Q</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="localidad"
                  label="Localidad"
                  name="localidad"
                  inputProps={{ maxLength: 200 }}
                  multiline
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="meta"
                  label="Meta según PEI"
                  inputProps={{ maxLength: 100 }}
                  name="meta"
                  multiline
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="resultado"
                  label="Resultado esperado"
                  inputProps={{ maxLength: 500 }}
                  name="resultado"
                  multiline
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} padding={2} rowSpacing={1}>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Catálogo"
                  endpoint={"/catalogo/listActive"}
                  selectedItem={catalogo}
                  setSelectedItem={setCatalogo}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Producto"
                  endpoint={
                    catalogo.Id !== ""
                      ? `/producto/listActive/${catalogo.Id}`
                      : undefined
                  }
                  selectedItem={producto}
                  setSelectedItem={setProducto}
                  disabled={catalogo.Id === ""}
                  hierarchyUpdated={catalogo}
                />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}>
                  {unidades.map((unidad, index) => {
                    return (
                      <>
                        <UnidadMedida
                          key={index}
                          index={index}
                          unidades={unidades}
                          setUnidades={setUnidades}
                        />
                        <Divider />
                      </>
                    );
                  })}
                </Box>
                <IconButton
                  color="success"
                  sx={{ borderRadius: "0" }}
                  onClick={() => agregarUnidad()}
                >
                  <AddCircleTwoToneIcon />
                  <Typography sx={{ margin: 0 }} component="p">
                    Agregar unidad de medida
                  </Typography>
                </IconButton>
                <IconButton
                  color="error"
                  sx={{ borderRadius: "0" }}
                  onClick={() => eliminarUnidad()}
                  disabled={!(unidades.length > 1)}
                >
                  <RemoveCircleTwoToneIcon />
                  <Typography sx={{ margin: 0 }} component="p">
                    Eliminar unidad de medida
                  </Typography>
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Box>
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{ mb: 2 }}
                padding={1}
              >
                Agregar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { ActividadAgregar };
